var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #bcbccb;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_search",
    className: "cls-1",
    d: "M15.081,13.335a8.047,8.047,0,0,0,1.663-4.957A8.336,8.336,0,0,0,8.431,0,8.438,8.438,0,0,0,0,8.379a8.438,8.438,0,0,0,8.431,8.379,7.917,7.917,0,0,0,4.988-1.652l3.563,3.54a1.153,1.153,0,0,0,1.663,0,1.136,1.136,0,0,0,0-1.652Zm-6.65.944a5.963,5.963,0,0,1-6.056-5.9,6.056,6.056,0,0,1,12.113,0A5.963,5.963,0,0,1,8.431,14.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.13bc25428f6e8523d22fb4c1ffcb0450.svg";
export { ForwardRef as ReactComponent };